export function contracttoBuyandSellIncomeResidential2026() {
return [   // Release 2025-12-27 09:28:31
 {
   page: 0,
 name: "Logo",
 type: "logo",
 top: 28.673,
 left: 53,
 width: 240,
 height: 36,
 }, 
{
   page: 0,
   name: "Radiobutton NumberOfUnits One to Four", 
   isText: false,
   type: "checkbox",
   top: 237.0,
   left: 210.12,
   width: 12.24,
   height: 12.24
}
,
{
   page: 0,
   name: "Radiobutton NumberOfUnits More Than Four", 
   isText: false,
   type: "checkbox",
   top: 237.0,
   left: 287.16,
   width: 12.24,
   height: 12.895
}
,
{
   page: 0,
   name: "Date", 
   fontSize: 9,
   type: "date",
   top: 253.44,
   left: 447.36,
   width: 133.32,
   height: 12.447
}
,
{
   page: 0,
   name: "Buyer", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 364.96,
   left: 110.16,
   width: 424.92,
   height: 12.447
}
,
{
   page: 0,
   name: "Radiobutton Title Joint Tenants", 
   isText: false,
   type: "checkbox",
   top: 397.311,
   left: 63.4912,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 0,
   name: "Radiobutton Title Tenants In Common", 
   isText: false,
   type: "checkbox",
   top: 412.365,
   left: 63.4912,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 0,
   name: "Radiobutton Title Other", 
   isText: false,
   type: "checkbox",
   top: 426.766,
   left: 63.4912,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 0,
   name: "Title Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 424.4,
   left: 122.64,
   width: 450.00,
   height: 12.447
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 459.28,
   left: 113.52,
   width: 465.00,
   height: 12.447
}
,
{
   page: 0,
   name: "Address County", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 485.2,
   left: 428.16,
   width: 149.88,
   height: 12.447
}
,
{
   page: 0,
   name: "Address Legal Description", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 509.239,
   left: 45.8184,
   width: 532.9106,
   height: 223.6005
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 732.7636,
   left: 95.4,
   width: 474.96,
   height: 13.7564
}
,
{
   page: 1,
   name: "Number of Remote Controls", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 138.72,
   left: 111.48,
   width: 79.92,
   height: 12.84
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Solar Panels", 
   isText: false,
   type: "checkbox",
   top: 155.64,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Water Softeners", 
   isText: false,
   type: "checkbox",
   top: 172.44,
   left: 63.72,
   width: 10.08,
   height: 10.735
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Security Systems", 
   isText: false,
   type: "checkbox",
   top: 189.24,
   left: 63.72,
   width: 10.08,
   height: 10.735
}
,
{
   page: 1,
   name: "Checkbox Group Inclusions Satellite Systems", 
   isText: false,
   type: "checkbox",
   top: 206.04,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Inclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 308.874,
   left: 55.6366,
   width: 525.0564,
   height: 207.237
}
,
{
   page: 1,
   name: "Checkbox ChecklistItem Personal Property Agreement", 
   isText: false,
   type: "checkbox",
   top: 517.32,
   left: 63.72,
   width: 9.12,
   height: 9.12
}
,
{
   page: 1,
   name: "Inclusions Encumbered", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 600.875,
   left: 54.9821,
   width: 527.0199,
   height: 130.6554
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeDebtOnEncumberedInclusions Will", 
   isText: false,
   type: "checkbox",
   top: 734.76,
   left: 84.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 1,
   name: "Radiobutton BuyerAssumeDebtOnEncumberedInclusions Will Not", 
   isText: false,
   type: "checkbox",
   top: 734.76,
   left: 130.2,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Parking 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 85.909,
   left: 456.24,
   width: 122.52,
   height: 12.851
}
,
{
   page: 2,
   name: "Parking", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 100.491,
   left: 62.8366,
   width: 513.9294,
   height: 13.491
}
,
{
   page: 2,
   name: "Storage Facilities", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 115.669,
   left: 303.36,
   width: 275.04,
   height: 12.851
}
,
{
   page: 2,
   name: "Storage Facilities Field 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 131.48,
   left: 62.88,
   width: 514.92,
   height: 12.196
}
,
{
   page: 2,
   name: "Leased Items", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 188.51,
   left: 57.6003,
   width: 525.7107,
   height: 169.928
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeDebtOnLeasedItems Will", 
   isText: false,
   type: "checkbox",
   top: 360.84,
   left: 93.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton BuyerAssumeDebtOnLeasedItems Will Not", 
   isText: false,
   type: "checkbox",
   top: 360.84,
   left: 143.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Checkbox ChecklistItem Solar Power Plan", 
   isText: false,
   type: "checkbox",
   top: 405.24,
   left: 90.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will", 
   isText: false,
   type: "checkbox",
   top: 432.6,
   left: 334.68,
   width: 10.08,
   height: 10.735
}
,
{
   page: 2,
   name: "Radiobutton AssumeSolarPowerPlan Will Not", 
   isText: false,
   type: "checkbox",
   top: 432.6,
   left: 385.56,
   width: 10.08,
   height: 10.735
}
,
{
   page: 2,
   name: "Exclusions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 487.639,
   left: 43.8547,
   width: 538.8013,
   height: 140.473
}
,
{
   page: 2,
   name: "Checkbox Group WaterRights Deeded Water Rights", 
   isText: false,
   type: "checkbox",
   top: 645.24,
   left: 90.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 657.821,
   left: 51.0548,
   width: 529.6382,
   height: 84.1822
}
,
{
   page: 2,
   name: "WaterRights Deeded Water Rights Deed", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 745.4145,
   left: 318.48,
   width: 186.60,
   height: 12.1964
}
,
{
   page: 3,
   name: "Checkbox Group WaterRights Other Rights Relating to Water", 
   isText: false,
   type: "checkbox",
   top: 45.96,
   left: 90.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "WaterRights Other Rights Relating To Water", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 69.382,
   left: 51.0548,
   width: 532.9112,
   height: 90.728
}
,
{
   page: 3,
   name: "Checkbox Group WaterRights Well Rights", 
   isText: false,
   type: "checkbox",
   top: 161.4,
   left: 90.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "WaterRights Well Permit Number", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 230.68,
   left: 144.96,
   width: 432.24,
   height: 13.80
}
,
{
   page: 3,
   name: "Checkbox Group WaterRights Water Stock", 
   isText: false,
   type: "checkbox",
   top: 250.44,
   left: 90.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 3,
   name: "WaterRights Water Stock", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 263.128,
   left: 53.0184,
   width: 530.2926,
   height: 63.237
}
,
{
   page: 3,
   name: "Time of Day Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 455.64,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateAlternative Earnest Money Deadline", 
   fontSize: 9,
   type: "date",
   top: 483.72,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "Alternative Earnest Money Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 483.72,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateRecord Title Deadline and Tax Certificate", 
   fontSize: 9,
   type: "date",
   top: 523.8,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "Record Title Deadline and Tax Certificate", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 523.8,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 551.88,
   left: 279.32,
   width: 62.037,
   height: 26.76
}
,
{
   page: 3,
   name: "Record Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 551.88,
   left: 343.815,
   width: 235.665,
   height: 26.76
}
,
{
   page: 3,
   name: "DateOffRecord Title Deadline", 
   fontSize: 9,
   type: "date",
   top: 580.2,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "OffRecord Title Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 580.2,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateOffRecord Title Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 608.28,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "OffRecord Title Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 608.28,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateTitle Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 636.36,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "Title Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 636.36,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateThird Party Right to PurchaseApprove Deadline", 
   fontSize: 9,
   type: "date",
   top: 664.44,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "Third Party Right to PurchaseApprove Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 664.44,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateAssociation Documents Deadline", 
   fontSize: 9,
   type: "date",
   top: 704.52,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "Association Documents Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 704.52,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 3,
   name: "DateAssociation Documents Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 732.6,
   left: 279.32,
   width: 62.037,
   height: 26.52
}
,
{
   page: 3,
   name: "Association Documents Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 732.6,
   left: 343.815,
   width: 235.665,
   height: 26.52
}
,
{
   page: 4,
   name: "DateSellers Property Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 88.382,
   left: 279.32,
   width: 61.215,
   height: 19.119
}
,
{
   page: 4,
   name: "Sellers Property Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 85.56,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateLeadBased Paint Disclosure Deadline", 
   fontSize: 9,
   type: "date",
   top: 115.64,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "LeadBased Paint Disclosure Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 113.64,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateNew Loan Application Deadline", 
   fontSize: 9,
   type: "date",
   top: 155.72,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "New Loan Application Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 153.72,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateNew Loan Terms Deadline", 
   fontSize: 9,
   type: "date",
   top: 183.8,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "New Loan Terms Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 181.8,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateNew Loan Availability Deadline", 
   fontSize: 9,
   type: "date",
   top: 211.88,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "New Loan Availability Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 209.88,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateBuyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 239.96,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 237.96,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateDisapproval of Buyers Credit Information Deadline", 
   fontSize: 9,
   type: "date",
   top: 268.04,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Disapproval of Buyers Credit Information Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 266.04,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateExisting Loan Deadline", 
   fontSize: 9,
   type: "date",
   top: 296.12,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Existing Loan Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 294.12,
   left: 342.992,
   width: 236.488,
   height: 26.76
}
,
{
   page: 4,
   name: "DateExisting Loan Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 324.44,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Existing Loan Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 322.44,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateLoan Transfer Approval Deadline", 
   fontSize: 9,
   type: "date",
   top: 352.52,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Loan Transfer Approval Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 350.52,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateSeller or Private Financing Deadline", 
   fontSize: 9,
   type: "date",
   top: 380.6,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Seller or Private Financing Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 378.6,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateAppraisal Deadline", 
   fontSize: 9,
   type: "date",
   top: 420.68,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Appraisal Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 418.68,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateAppraisal Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 448.76,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Appraisal Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 446.76,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateAppraisal Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 476.84,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Appraisal Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 474.84,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Deadline", 
   fontSize: 9,
   type: "date",
   top: 516.92,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "New ILC or New Survey Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 514.92,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 545.0,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "New ILC or New Survey Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 543.0,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateNew ILC or New Survey Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 573.08,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "New ILC or New Survey Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 571.08,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateWater Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 613.16,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Water Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 611.16,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateMineral Rights Examination Deadline", 
   fontSize: 9,
   type: "date",
   top: 641.24,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Mineral Rights Examination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 639.24,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateInspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 669.32,
   left: 279.32,
   width: 61.215,
   height: 19.941
}
,
{
   page: 4,
   name: "Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 667.32,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 4,
   name: "DateInspection Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 697.4,
   left: 279.32,
   width: 61.215,
   height: 19.9405
}
,
{
   page: 4,
   name: "Inspection Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 695.4,
   left: 342.992,
   width: 236.488,
   height: 26.76
}
,
{
   page: 4,
   name: "DateInspection Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 725.72,
   left: 279.32,
   width: 61.215,
   height: 19.9406
}
,
{
   page: 4,
   name: "Inspection Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 723.72,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateProperty Insurance Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 76.56,
   left: 280.32,
   width: 60.392,
   height: 18.296
}
,
{
   page: 5,
   name: "Property Insurance Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 73.56,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateDue Diligence Documents Delivery Deadline", 
   fontSize: 9,
   type: "date",
   top: 104.64,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Due Diligence Documents Delivery Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 101.64,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateDue Diligence Documents Objection Deadline", 
   fontSize: 9,
   type: "date",
   top: 132.72,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Due Diligence Documents Objection Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 129.72,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateDue Diligence Documents Resolution Deadline", 
   fontSize: 9,
   type: "date",
   top: 160.8,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Due Diligence Documents Resolution Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 157.8,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateEnvironmental Inspection Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 188.88,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Environmental Inspection Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 185.88,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateADA Evaluation Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 216.96,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "ADA Evaluation Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 213.96,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateConditional Sale Deadline", 
   fontSize: 9,
   type: "date",
   top: 245.04,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Conditional Sale Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 242.04,
   left: 342.992,
   width: 236.488,
   height: 26.76
}
,
{
   page: 5,
   name: "DateLeadBased Paint Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 273.36,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "LeadBased Paint Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 270.36,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateEstoppel Statements Deadline", 
   fontSize: 9,
   type: "date",
   top: 301.44,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Estoppel Statements Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 298.44,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateEstoppel Statements Termination Deadline", 
   fontSize: 9,
   type: "date",
   top: 329.52,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Estoppel Statements Termination Deadline", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 326.52,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateClosing Date", 
   fontSize: 9,
   type: "date",
   top: 369.6,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Closing Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 366.6,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DatePossession Date", 
   fontSize: 9,
   type: "date",
   top: 397.68,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Possession Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 394.68,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "Possession Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 422.76,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "DateAcceptance Deadline Date", 
   fontSize: 9,
   type: "date",
   top: 453.84,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Acceptance Deadline Date", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 450.84,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "Acceptance Deadline Time", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 478.92,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "Deadlines Extra Row Item No 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 509.239,
   left: 41.4,
   width: 25.56,
   height: 17.760
}
,
{
   page: 5,
   name: "Deadlines Extra Row Reference 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 506.16,
   left: 69.4801,
   width: 29.6399,
   height: 27.36
}
,
{
   page: 5,
   name: "Deadlines Extra Row Title 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 507,
   left: 100.32,
   width: 177.72,
   height: 26.52
}
,
{
   page: 5,
   name: "Date Deadlines Extra Row 1", 
   fontSize: 9,
   type: "date",
   top: 507.0,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Deadlines Extra Row 1", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 507.0,
   left: 342.992,
   width: 236.488,
   height: 26.52
}
,
{
   page: 5,
   name: "Deadlines Extra Row Item No 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.72,
   left: 41.4,
   width: 25.56,
   height: 17.76
}
,
{
   page: 5,
   name: "Deadlines Extra Row Reference 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.72,
   left: 68.52,
   width: 29.88,
   height: 17.76
}
,
{
   page: 5,
   name: "Deadlines Extra Row Title 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.72,
   left: 99.96,
   width: 178.44,
   height: 17.76
}
,
{
   page: 5,
   name: "Date Deadlines Extra Row 2", 
   fontSize: 9,
   type: "date",
   top: 534.72,
   left: 280.32,
   width: 60.392,
   height: 17.473
}
,
{
   page: 5,
   name: "Deadlines Extra Row 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 534.72,
   left: 342.992,
   width: 236.488,
   height: 17.76
}
,
{
   page: 6,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will", 
   isText: false,
   type: "checkbox",
   top: 59.88,
   left: 63.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 6,
   name: "Radiobutton DeadlinesExtendedToNextBusinessDay Will Not", 
   isText: false,
   type: "checkbox",
   top: 59.88,
   left: 112.68,
   width: 11.28,
   height: 11.28
}
,
{
   page: 6,
   name: "Amount Purchase Price", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 145.68,
   left: 327.2,
   width: 84.382,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Earnest Money", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 164.4,
   left: 425.924,
   width: 85.538,
   height: 16.211
}
,
{
   page: 6,
   name: "Amount New Loan", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 183.12,
   left: 425.924,
   width: 85.538,
   height: 17.28
}
,
{
   page: 6,
   name: "Amount Assumption Balance", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 201.6,
   left: 425.924,
   width: 85.538,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Private Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 220.32,
   left: 425.924,
   width: 85.538,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Seller Financing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 239.04,
   left: 425.924,
   width: 85.538,
   height: 17.52
}
,
{
   page: 6,
   name: "Item 7 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.76,
   left: 144.84,
   width: 48.12,
   height: 17.52
}
,
{
   page: 6,
   name: "Item 7 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.76,
   left: 194.52,
   width: 119.88,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Item 7 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.76,
   left: 327.2,
   width: 84.382,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Item 7 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 257.76,
   left: 425.924,
   width: 85.538,
   height: 17.52
}
,
{
   page: 6,
   name: "Item 8 Reference", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 276.48,
   left: 144.84,
   width: 48.12,
   height: 17.52
}
,
{
   page: 6,
   name: "Item 8 Description", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 276.48,
   left: 194.52,
   width: 119.88,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 276.48,
   left: 327.2,
   width: 84.382,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Item 8 Credit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 276.48,
   left: 425.924,
   width: 85.538,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Cash At Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 294.855,
   left: 425.924,
   width: 85.538,
   height: 17.280
}
,
{
   page: 6,
   name: "CALCULATE Amount Purchase Price PLUS Amount Item 7 Debit PLUS Amount Item 8 Debit", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 313.68,
   left: 327.2,
   width: 84.382,
   height: 17.52
}
,
{
   page: 6,
   name: "CALCULATE Amount Earnest Money PLUS Amount New Loan PLUS Amount Assumption Balance PLUS Amount Private Financing PLUS Amount Seller Financing PLUS Amount Item 7 Credit PLUS Amount Item 8 Credit PLUS Amount Cash At Closing", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 313.68,
   left: 425.924,
   width: 85.538,
   height: 17.52
}
,
{
   page: 6,
   name: "Amount Seller Concession", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 341.516,
   left: 351.676,
   width: 143.423,
   height: 12.284
}
,
{
   page: 6,
   name: "Earnest Money Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 426.96,
   left: 54.24,
   width: 425.04,
   height: 13.56
}
,
{
   page: 6,
   name: "Earnest Money Holder", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 442.68,
   left: 87.84,
   width: 386.52,
   height: 13.56
}
,
{
   page: 7,
   name: "Radiobutton AvailableFunds Does have funds", 
   isText: false,
   type: "checkbox",
   top: 109.8,
   left: 421.56,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Radiobutton AvailableFunds Does not have funds", 
   isText: false,
   type: "checkbox",
   top: 109.8,
   left: 474.36,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group Loan Conventional", 
   isText: false,
   type: "checkbox",
   top: 220.2,
   left: 63.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group Loan FHA", 
   isText: false,
   type: "checkbox",
   top: 220.2,
   left: 153,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group Loan VA", 
   isText: false,
   type: "checkbox",
   top: 220.2,
   left: 205.08,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group Loan Bond", 
   isText: false,
   type: "checkbox",
   top: 220.2,
   left: 252.84,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group Loan Other", 
   isText: false,
   type: "checkbox",
   top: 220.2,
   left: 311.4,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Loan Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 218.28,
   left: 360.72,
   width: 215.04,
   height: 12.84
}
,
{
   page: 7,
   name: "Amount FHA VA Closing Costs Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 245.28,
   left: 454.32,
   width: 120.00,
   height: 12.36
}
,
{
   page: 7,
   name: "Amount Assumption At", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 337.2,
   left: 278.4,
   width: 95.04,
   height: 12.84
}
,
{
   page: 7,
   name: "Assumption Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 337.2,
   left: 391.2,
   width: 120.0,
   height: 12.84
}
,
{
   page: 7,
   name: "Assumption Rate", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 350.88,
   left: 232.92,
   width: 79.92,
   height: 12.84
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Real Estate Taxes", 
   isText: false,
   type: "checkbox",
   top: 367.8,
   left: 103.08,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Property Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 367.8,
   left: 213.24,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Mortgage Insurance Premium", 
   isText: false,
   type: "checkbox",
   top: 367.8,
   left: 373.08,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Checkbox Group AssumptionEscrow Other", 
   isText: false,
   type: "checkbox",
   top: 383.627,
   left: 55.2502,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 7,
   name: "AssumptionEscrow Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 380.88,
   left: 76.2,
   width: 496.56,
   height: 12.84
}
,
{
   page: 7,
   name: "Amount Assumption Loan Transfer Fee Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 398.16,
   left: 273.96,
   width: 99.96,
   height: 12.84
}
,
{
   page: 7,
   name: "Percent Assumption Loan Interest Rate Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 411.84,
   left: 117.6,
   width: 65.04,
   height: 12.84
}
,
{
   page: 7,
   name: "Amount Assumption New Payment Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 411.84,
   left: 399.84,
   width: 84.96,
   height: 12.84
}
,
{
   page: 7,
   name: "Assumption New Payment Per", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 425.76,
   left: 54.12,
   width: 169.92,
   height: 12.84
}
,
{
   page: 7,
   name: "Amount Assumption Cash At Closing Increase Max", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 453.36,
   left: 157.08,
   width: 99.96,
   height: 12.84
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will", 
   isText: false,
   type: "checkbox",
   top: 487.08,
   left: 82.92,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseSellerLiabilityOnLoan Will Not", 
   isText: false,
   type: "checkbox",
   top: 487.08,
   left: 131.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseDelivery On or Before Loan Transfer Approval Deadline", 
   isText: false,
   type: "checkbox",
   top: 500.76,
   left: 235.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Radiobutton AssumptionReleaseDelivery At Closing", 
   isText: false,
   type: "checkbox",
   top: 500.76,
   left: 462.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 7,
   name: "Assumption Release of Liability Paid By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525.36,
   left: 54.12,
   width: 294.96,
   height: 12.84
}
,
{
   page: 7,
   name: "Amount Assumption Release of Liability Max Cost", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 525.36,
   left: 469.08,
   width: 105.00,
   height: 12.84
}
,
{
   page: 7,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Buyer", 
   isText: false,
   type: "checkbox",
   top: 648.36,
   left: 68.28,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Radiobutton SellerFinancingDeliversFinancingDocuments Seller", 
   isText: false,
   type: "checkbox",
   top: 648.36,
   left: 124.68,
   width: 11.28,
   height: 11.28
}
,
{
   page: 7,
   name: "Seller Financing Deliver Financing Documents Number Days before Seller or Private Financing Deadline", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 646.32,
   left: 509.28,
   width: 69.96,
   height: 12.84
}
,
{
   page: 9,
   name: "Amount FHA Minimum Appraised Value", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 140.16,
   left: 314.64,
   width: 105.00,
   height: 10.68
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysAppraisal Buyer", 
   isText: false,
   type: "checkbox",
   top: 347.88,
   left: 54.6,
   width: 11.28,
   height: 11.28
}
,
{
   page: 9,
   name: "Radiobutton WhoPaysAppraisal Seller", 
   isText: false,
   type: "checkbox",
   top: 347.88,
   left: 112.44,
   width: 11.28,
   height: 11.28
}
,
{
   page: 10,
   name: "Radiobutton WhoSelectsTitleCompany Seller", 
   isText: false,
   type: "checkbox",
   top: 391.56,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Checkbox Abstract of Title", 
   isText: false,
   type: "checkbox",
   top: 432.84,
   left: 147.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoSelectsTitleCompany Buyer", 
   isText: false,
   type: "checkbox",
   top: 463.56,
   left: 95.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton TitleContainsOEC Will", 
   isText: false,
   type: "checkbox",
   top: 524.76,
   left: 354.36,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton TitleContainsOEC Will Not", 
   isText: false,
   type: "checkbox",
   top: 524.76,
   left: 401.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysOEC Buyer", 
   isText: false,
   type: "checkbox",
   top: 593.64,
   left: 83.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysOEC Seller", 
   isText: false,
   type: "checkbox",
   top: 593.64,
   left: 138.84,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysOEC Split", 
   isText: false,
   type: "checkbox",
   top: 593.64,
   left: 198.12,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "Radiobutton WhoPaysOEC Other", 
   isText: false,
   type: "checkbox",
   top: 607.32,
   left: 63.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 10,
   name: "WhoPaysOEC Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 604.32,
   left: 105.84,
   width: 469.92,
   height: 12.84
}
,
{
   page: 11,
   name: "Website Metro District", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 551.76,
   left: 128.4,
   width: 444.96,
   height: 12.96
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysTaxCertificate Seller", 
   isText: false,
   type: "checkbox",
   top: 571.8,
   left: 276.84,
   width: 11.28,
   height: 11.28
}
,
{
   page: 11,
   name: "Radiobutton WhoPaysTaxCertificate Buyer", 
   isText: false,
   type: "checkbox",
   top: 571.8,
   left: 339.24,
   width: 11.28,
   height: 11.28
}
,
{
   page: 12,
   name: "Checkbox Group ILCorSurvey New ILC", 
   isText: false,
   type: "checkbox",
   top: 627.48,
   left: 81.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Checkbox Group ILCorSurvey New Survey", 
   isText: false,
   type: "checkbox",
   top: 644.28,
   left: 81.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Survey Form", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 643.742,
   left: 211.92,
   width: 154.92,
   height: 11.378
}
,
{
   page: 12,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 661.08,
   left: 270.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Radiobutton WhoOrdersNew_ILC_OrSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 661.08,
   left: 328.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Radiobutton WhoPaysNewILCorSurvey Seller", 
   isText: false,
   type: "checkbox",
   top: 719.16,
   left: 88.44,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "Radiobutton WhoPaysNewILCorSurvey Buyer", 
   isText: false,
   type: "checkbox",
   top: 719.16,
   left: 147.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 12,
   name: "WhoPaysNewILCorSurvey Other", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 729.8214,
   left: 81.164,
   width: 498.220,
   height: 34.4364
}
,
{
   page: 13,
   name: "Delivery ILC", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 56.88,
   left: 220.68,
   width: 339.96,
   height: 12.84
}
,
{
   page: 14,
   name: "Occupancy Agreements", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 242.183,
   left: 68.0731,
   width: 513.9289,
   height: 99.891
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem All contracts relating to the operation maintenance and management of the Property", 
   isText: false,
   type: "checkbox",
   top: 485.16,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Property tax bills for the last number of years", 
   isText: false,
   type: "checkbox",
   top: 501.96,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Number of Years of Property Tax Bills", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 499.484,
   left: 290.76,
   width: 84.96,
   height: 12.316
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem As built construction plans to the Property and the tenant improvements including architectural electrical mechanical and structural systems engineering reports permanent Certificates of Occupancy", 
   isText: false,
   type: "checkbox",
   top: 518.76,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem A list of all Inclusions to be conveyed to Buyer", 
   isText: false,
   type: "checkbox",
   top: 561.48,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Operating statements for the past number of years", 
   isText: false,
   type: "checkbox",
   top: 577.56,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Number of Years Operating statements", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 575.607,
   left: 311.28,
   width: 84.96,
   height: 11.793
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem A rent roll accurate and correct to the date of this Contract", 
   isText: false,
   type: "checkbox",
   top: 594.36,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem A schedule of any tenant improvement work Seller is obligated to complete but has not yet completed", 
   isText: false,
   type: "checkbox",
   top: 611.16,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem All insurance policies pertaining to the Property and copies of any claims which have been made for the past number of years", 
   isText: false,
   type: "checkbox",
   top: 641.88,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Number of Years copies of insurance policies", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 654.654,
   left: 150.36,
   width: 85.08,
   height: 10.746
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Soils reports surveys and engineering reports or data pertaining to the Property if not delivered earlier", 
   isText: false,
   type: "checkbox",
   top: 673.8,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 14,
   name: "Checkbox ChecklistItem Any and all existing documentation and reports regarding Phase I and II environmental reports", 
   isText: false,
   type: "checkbox",
   top: 705.24,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Checkbox ChecklistItem Any Americans with Disabilities Act reports studies or surveys concerning the compliance of the Property with said Act", 
   isText: false,
   type: "checkbox",
   top: 62.52,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Checkbox ChecklistItem All permits licenses and other building or use authorizations issued by any governmental authority", 
   isText: false,
   type: "checkbox",
   top: 91.8,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Checkbox ChecklistItem Other Documents", 
   isText: false,
   type: "checkbox",
   top: 134.52,
   left: 158.28,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "ChecklistItem Other Documents", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 145.31,
   left: 92.2913,
   width: 492.3287,
   height: 127.775
}
,
{
   page: 15,
   name: "Radiobutton WhoProvidesPhaseI_EnvironmentalSiteAssessment Seller", 
   isText: false,
   type: "checkbox",
   top: 535.32,
   left: 314.2,
   width: 10.735,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton WhoProvidesPhaseI_EnvironmentalSiteAssessment Buyer", 
   isText: false,
   type: "checkbox",
   top: 535.32,
   left: 361.32,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Due Diligence Environmental", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 562.383,
   left: 273.337,
   width: 304.996,
   height: 10.480
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysEnvironmentalInspection Seller", 
   isText: false,
   type: "checkbox",
   top: 575.92,
   left: 160.0,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysEnvironmentalInspection Buyer", 
   isText: false,
   type: "checkbox",
   top: 575.92,
   left: 208.48,
   width: 10.08,
   height: 10.08
}
,
{
   page: 15,
   name: "Inspection Termination Deadline will be extended by", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 606.019,
   left: 421.88,
   width: 84.96,
   height: 10.909
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysPhaseII_EnvironmentalInspection Seller", 
   isText: false,
   type: "checkbox",
   top: 648.24,
   left: 91.7964,
   width: 9.6436,
   height: 10.08
}
,
{
   page: 15,
   name: "Radiobutton WhoPaysPhaseII_EnvironmentalInspection Buyer", 
   isText: false,
   type: "checkbox",
   top: 648.24,
   left: 135.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Conditional Sale of Property Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 96.219,
   left: 60.2184,
   width: 512.6196,
   height: 12.181
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does", 
   isText: false,
   type: "checkbox",
   top: 158.76,
   left: 473.64,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptOfSPD Does Not", 
   isText: false,
   type: "checkbox",
   top: 158.76,
   left: 522.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Checkbox Well There is no well", 
   isText: false,
   type: "checkbox",
   top: 186.12,
   left: 128.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does", 
   isText: false,
   type: "checkbox",
   top: 186.12,
   left: 251.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 16,
   name: "Radiobutton AcknowledgeReceiptWellPermit Does Not", 
   isText: false,
   type: "checkbox",
   top: 186.12,
   left: 293.4,
   width: 10.08,
   height: 10.08
}
,
{
   page: 17,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are", 
   isText: false,
   type: "checkbox",
   top: 489.72,
   left: 423,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "Radiobutton ClosingInstructionsExecutedWithContract Are Not", 
   isText: false,
   type: "checkbox",
   top: 489.72,
   left: 466.68,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "Closing Designated By", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 553.451,
   left: 59.5639,
   width: 506.2731,
   height: 11.515
}
,
{
   page: 17,
   name: "Radiobutton DeedType Special Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 664.92,
   left: 45.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "Radiobutton DeedType General Warranty Deed", 
   isText: false,
   type: "checkbox",
   top: 664.92,
   left: 163.32,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "Radiobutton DeedType Bargain And Sale Deed", 
   isText: false,
   type: "checkbox",
   top: 664.92,
   left: 282.12,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "Radiobutton DeedType Quit Claim Deed", 
   isText: false,
   type: "checkbox",
   top: 664.92,
   left: 395.4,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "Radiobutton DeedType Personal Representatives Deed", 
   isText: false,
   type: "checkbox",
   top: 683.16,
   left: 45.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "Radiobutton DeedType Deed Other", 
   isText: false,
   type: "checkbox",
   top: 683.16,
   left: 199.08,
   width: 11.28,
   height: 11.28
}
,
{
   page: 17,
   name: "DeedType Deed Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 681.487,
   left: 218.64,
   width: 304.92,
   height: 13.473
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 168.36,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 168.84,
   left: 131.16,
   width: 9.60,
   height: 9.60
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 168.36,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ClosingServicesFeePaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 167.4,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "ClosingServicesFeePaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 163.669,
   left: 455.52,
   width: 118.44,
   height: 14.651
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 261.72,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 262.2,
   left: 131.16,
   width: 9.60,
   height: 9.6
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 261.72,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton RecordChangeFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 260.76,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 309.24,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 309.72,
   left: 131.16,
   width: 9.60,
   height: 9.60
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 309.24,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton ReservesOrWorkingCapitalPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 308.28,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 344.28,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 344.76,
   left: 131.16,
   width: 9.60,
   height: 9.60
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 344.28,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton OtherFeesPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 343.32,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 379.32,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 379.8,
   left: 131.16,
   width: 9.60,
   height: 9.6
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 379.32,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton LocalTransferTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 378.36,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 414.36,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 414.84,
   left: 131.16,
   width: 9.60,
   height: 9.60
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 414.36,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton SalesAndUseTaxPaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 413.4,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 463.08,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 463.56,
   left: 131.16,
   width: 9.60,
   height: 9.60
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 463.08,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton PrivateTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 462.12,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "Amount Water Transfer Fee", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 494.172,
   left: 56.52,
   width: 90.00,
   height: 13.828
}
,
{
   page: 18,
   name: "Checkbox Group WaterTransferFees Water DistrictMunicipality", 
   isText: false,
   type: "checkbox",
   top: 513.82,
   left: 49.7457,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 18,
   name: "Checkbox Group WaterTransferFees Water Stock", 
   isText: false,
   type: "checkbox",
   top: 513.166,
   left: 225.165,
   width: 10.080,
   height: 10.080
}
,
{
   page: 18,
   name: "Checkbox Group WaterTransferFees Augmentation Membership", 
   isText: false,
   type: "checkbox",
   top: 530.839,
   left: 49.0911,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 18,
   name: "Checkbox Group WaterTransferFees Small Domestic Water Company", 
   isText: false,
   type: "checkbox",
   top: 530.184,
   left: 224.51,
   width: 10.08,
   height: 10.080
}
,
{
   page: 18,
   name: "Checkbox Group WaterTransferFees Other", 
   isText: false,
   type: "checkbox",
   top: 530.184,
   left: 396.002,
   width: 10.080,
   height: 10.080
}
,
{
   page: 18,
   name: "WaterTransferFees Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 526.949,
   left: 410.88,
   width: 165.00,
   height: 14.651
}
,
{
   page: 18,
   name: "Radiobutton WaterTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 547.202,
   left: 179.001,
   width: 10.080,
   height: 10.080
}
,
{
   page: 18,
   name: "Radiobutton WaterTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 547.202,
   left: 233.365,
   width: 10.080,
   height: 10.080
}
,
{
   page: 18,
   name: "Radiobutton WaterTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 547.202,
   left: 286.692,
   width: 10.080,
   height: 10.080
}
,
{
   page: 18,
   name: "Radiobutton WaterTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 547.202,
   left: 495.839,
   width: 10.080,
   height: 10.080
}
,
{
   page: 18,
   name: "Radiobutton UtilityTransferFeePaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 582.12,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton UtilityTransferFeePaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 582.6,
   left: 131.16,
   width: 9.60,
   height: 9.6
}
,
{
   page: 18,
   name: "Radiobutton UtilityTransferFeePaidBy Split", 
   isText: false,
   type: "checkbox",
   top: 582.12,
   left: 189.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 18,
   name: "Radiobutton UtilityTransferFeePaidBy NA", 
   isText: false,
   type: "checkbox",
   top: 581.16,
   left: 405.72,
   width: 11.28,
   height: 11.28
}
,
{
   page: 18,
   name: "Checkbox IS a foreign person", 
   isText: false,
   type: "checkbox",
   top: 640.803,
   left: 546.548,
   width: 10.080,
   height: 10.080
}
,
{
   page: 19,
   name: "Radiobutton Taxes Taxes for the Calendar Year Immediately Preceding Closing", 
   isText: false,
   type: "checkbox",
   top: 127.32,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton Taxes Most Recent Mill Levy and Most Recent Assessed or Actual Valuation per the county assessor", 
   isText: false,
   type: "checkbox",
   top: 144.12,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton Taxes Other", 
   isText: false,
   type: "checkbox",
   top: 174.6,
   left: 72.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Taxes Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 171.72,
   left: 114.72,
   width: 459.96,
   height: 12.84
}
,
{
   page: 19,
   name: "Radiobutton Rents Actually Received", 
   isText: false,
   type: "checkbox",
   top: 191.4,
   left: 209.16,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton Rents Accrued", 
   isText: false,
   type: "checkbox",
   top: 191.4,
   left: 344.76,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Other Prorations", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 249.72,
   left: 72.12,
   width: 504.96,
   height: 12.84
}
,
{
   page: 19,
   name: "Radiobutton AssociationAssessmentsObligation Buyer", 
   isText: false,
   type: "checkbox",
   top: 346.68,
   left: 54.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Radiobutton AssociationAssessmentsObligation Seller", 
   isText: false,
   type: "checkbox",
   top: 346.68,
   left: 108.6,
   width: 10.08,
   height: 10.08
}
,
{
   page: 19,
   name: "Special Assessments", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 384.96,
   left: 203.04,
   width: 375.00,
   height: 12.84
}
,
{
   page: 19,
   name: "Amount Possession Per Day", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 466.8,
   left: 375.12,
   width: 85.08,
   height: 12.84
}
,
{
   page: 20,
   name: "Checkbox Specific Performance", 
   isText: false,
   type: "checkbox",
   top: 413.88,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 21,
   name: "Electronic Notice", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 530.88,
   left: 379.68,
   width: 195.60,
   height: 10.68
}
,
{
   page: 22,
   name: "Checkbox PaysBuyerBrokerage Seller", 
   isText: false,
   type: "checkbox",
   top: 45.818,
   left: 81.8185,
   width: 10.0800,
   height: 10.080
}
,
{
   page: 22,
   name: "Percent Seller Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 44.044,
   left: 97.68,
   width: 54.96,
   height: 12.687
}
,
{
   page: 22,
   name: "Amount Seller Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 44.044,
   left: 272.64,
   width: 90.00,
   height: 12.687
}
,
{
   page: 22,
   name: "Checkbox PaysBuyerBrokerage Buyer", 
   isText: false,
   type: "checkbox",
   top: 90.328,
   left: 81.164,
   width: 10.080,
   height: 10.080
}
,
{
   page: 22,
   name: "Percent Buyer Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 88.48,
   left: 98.16,
   width: 55.08,
   height: 12.687
}
,
{
   page: 22,
   name: "Amount Buyer Pays Buyers Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 88.48,
   left: 277.32,
   width: 90.00,
   height: 12.687
}
,
{
   page: 22,
   name: "Checkbox PaysBuyerBrokerage Sellers Brokerage", 
   isText: false,
   type: "checkbox",
   top: 135.492,
   left: 81.164,
   width: 10.080,
   height: 10.080
}
,
{
   page: 22,
   name: "Percent Seller Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 132.844,
   left: 99.96,
   width: 53.04,
   height: 12.687
}
,
{
   page: 22,
   name: "Amount Sellers Brokerage Pays Buyer Brokerage", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 132.844,
   left: 275.88,
   width: 90.00,
   height: 12.687
}
,
{
   page: 22,
   name: "Additional Provisions", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 250.037,
   left: 45.8184,
   width: 538.8016,
   height: 512.2572
}
,
{
   page: 23,
   name: "Documents Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 74.418,
   left: 47.782,
   width: 535.529,
   height: 55.382
}
,
{
   page: 23,
   name: "Checkbox ChecklistItem Post-Closing Occupancy Agreement", 
   isText: false,
   type: "checkbox",
   top: 131.8,
   left: 99.72,
   width: 10.08,
   height: 10.08
}
,
{
   page: 23,
   name: "Documents Not Part of Contract", 
   type: "textarea",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 172.801,
   left: 49.7457,
   width: 532.9103,
   height: 62.431
}
,
{
   page: 23,
   name: "Buyer 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 269.4,
   left: 130.56,
   width: 450.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 307.44,
   left: 130.56,
   width: 444.96,
   height: 14.04
}
,
{
   page: 23,
   name: "Buyer 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 322.44,
   left: 130.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 322.44,
   left: 443.04,
   width: 135.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 337.44,
   left: 130.56,
   width: 450.00,
   height: 14.04
}
,
{
   page: 23,
   name: "Buyer 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 360.36,
   left: 130.56,
   width: 450.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 398.28,
   left: 130.56,
   width: 444.96,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 413.16,
   left: 130.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 413.16,
   left: 443.04,
   width: 135.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 428.16,
   left: 130.56,
   width: 450.00,
   height: 14.04
}
,
{
   page: 23,
   name: "Buyer 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 451.08,
   left: 130.56,
   width: 450.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Buyer 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 500.52,
   left: 130.56,
   width: 450.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 1 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 573,
   left: 130.56,
   width: 450.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 1 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 611.04,
   left: 130.56,
   width: 444.96,
   height: 14.04
}
,
{
   page: 23,
   name: "Seller 1 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 625.8,
   left: 130.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 1 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 625.8,
   left: 443.04,
   width: 135.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 1 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 640.92,
   left: 130.56,
   width: 450.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 2 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 669.24,
   left: 130.56,
   width: 450.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 2 Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 707.16,
   left: 130.56,
   width: 444.96,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 2 Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 722.04,
   left: 130.56,
   width: 170.04,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 2 Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 722.04,
   left: 443.04,
   width: 135.00,
   height: 14.16
}
,
{
   page: 23,
   name: "Seller 2 Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 737.04,
   left: 130.56,
   width: 450.00,
   height: 14.04
}
,
{
   page: 24,
   name: "Seller 3 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 57.56,
   left: 130.56,
   width: 450.00,
   height: 12.196
}
,
{
   page: 24,
   name: "Seller 4 Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 113.28,
   left: 129.56,
   width: 450.00,
   height: 12.196
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 300.84,
   left: 91.56,
   width: 10.08,
   height: 10.08
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 300.84,
   left: 141.96,
   width: 10.08,
   height: 10.08
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerRelationship Buyers Agent", 
   isText: false,
   type: "checkbox",
   top: 385.08,
   left: 57.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerRelationship TransactionBroker", 
   isText: false,
   type: "checkbox",
   top: 400.2,
   left: 57.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 24,
   name: "Radiobutton BuyerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 415.08,
   left: 57.24,
   width: 10.08,
   height: 10.08
}
,
{
   page: 24,
   name: "Buyer Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 502.44,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 517.32,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 532.2,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 547.32,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Signature Buyer Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 569.148,
   left: 185.892,
   width: 185.345,
   height: 14.800
}
,
{
   page: 24,
   name: "Date Signature Buyer Broker", 
   fontSize: 9,
   type: "date",
   top: 568.855,
   left: 380.215,
   width: 90.000,
   height: 14.160
}
,
{
   page: 24,
   name: "Buyer Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 597.24,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 612.12,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 627,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 642.12,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 657,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Buyer CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 686.76,
   left: 184.56,
   width: 354.96,
   height: 14.16
}
,
{
   page: 24,
   name: "Signature Buyer CoAgent", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 710.2227,
   left: 184.224,
   width: 186.187,
   height: 12.9533
}
,
{
   page: 24,
   name: "Date Signature Buyer CoAgent", 
   fontSize: 9,
   type: "date",
   top: 707.88,
   left: 379.56,
   width: 90.00,
   height: 14.16
}
,
{
   page: 25,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does", 
   isText: false,
   type: "checkbox",
   top: 63.09,
   left: 94.9599,
   width: 10.0801,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton SellerBrokerAcknowledgeReceiptEarnestMoney Does Not", 
   isText: false,
   type: "checkbox",
   top: 63.09,
   left: 142.0,
   width: 10.08,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton SellerBrokerRelationship Sellers Agent", 
   isText: false,
   type: "checkbox",
   top: 147.09,
   left: 61.0799,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton SellerBrokerRelationship Transaction Broker", 
   isText: false,
   type: "checkbox",
   top: 162.21,
   left: 61.0799,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 25,
   name: "Radiobutton SellerBrokerRelationship Customer", 
   isText: false,
   type: "checkbox",
   top: 177.09,
   left: 61.0799,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 25,
   name: "Checkbox SellerBrokerageFirmPaidBy Seller", 
   isText: false,
   type: "checkbox",
   top: 218.97,
   left: 61.0799,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 25,
   name: "Checkbox SellerBrokerageFirmPaidBy Buyer", 
   isText: false,
   type: "checkbox",
   top: 233.85,
   left: 61.0799,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 25,
   name: "Checkbox SellerBrokerageFirmPaidBy Other", 
   isText: false,
   type: "checkbox",
   top: 249.69,
   left: 61.0799,
   width: 10.0800,
   height: 10.08
}
,
{
   page: 25,
   name: "SellerBrokerageFirmPaidBy Other", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 247.61,
   left: 107.88,
   width: 449.291,
   height: 12.851
}
,
{
   page: 25,
   name: "Seller Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 310.73,
   left: 184.734,
   width: 354.960,
   height: 12.788
}
,
{
   page: 25,
   name: "Seller Brokerage Firm License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 325.61,
   left: 184.08,
   width: 354.96,
   height: 12.788
}
,
{
   page: 25,
   name: "Seller Broker Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 340.49,
   left: 184.08,
   width: 354.96,
   height: 12.788
}
,
{
   page: 25,
   name: "Seller Broker License", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 355.37,
   left: 184.734,
   width: 354.960,
   height: 12.788
}
,
{
   page: 25,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 383.808,
   left: 184.583,
   width: 183.618,
   height: 13.175
}
,
{
   page: 25,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 383.37,
   left: 379.08,
   width: 90.00,
   height: 14.16
}
,
{
   page: 25,
   name: "Seller Brokerage Address Street", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 422.37,
   left: 184.08,
   width: 354.96,
   height: 14.16
}
,
{
   page: 25,
   name: "Seller Brokerage Address City State Zip", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 437.25,
   left: 184.08,
   width: 354.96,
   height: 14.16
}
,
{
   page: 25,
   name: "Seller Broker Phone", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 452.13,
   left: 184.08,
   width: 354.96,
   height: 14.16
}
,
{
   page: 25,
   name: "Seller Broker Fax", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 467.01,
   left: 184.08,
   width: 354.96,
   height: 14.16
}
,
{
   page: 25,
   name: "Seller Broker Email", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 8,
   top: 482.13,
   left: 184.08,
   width: 354.96,
   height: 14.16
}
,
{
   page: 25,
   name: "Seller CoAgent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 511.545,
   left: 184.08,
   width: 354.96,
   height: 14.160
}
,
{
   page: 25,
   name: "Signature CoAgent Seller", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 537.554,
   left: 186.546,
   width: 181.561,
   height: 15.825
}
,
{
   page: 25,
   name: "Date Signature Seller CoAgent", 
   fontSize: 9,
   type: "date",
   top: 538.01,
   left: 379.08,
   width: 90.00,
   height: 14.16
}
] }
